const clearId = ref(null)

export const useAnimate = (sliderValue, maxIndex) => {
  const isPlaying = ref(true)

  const anime = () => {
    if (!isPlaying.value) return
    if (sliderValue.value < maxIndex.value) {
      sliderValue.value++
    } else {
      sliderValue.value = 0
    }
    clearId.value = setTimeout(anime, sliderValue.value === maxIndex.value ? 2000 : 1000)
  }

  const onClickPlay = () => {
    isPlaying.value = true
    clearTimeout(clearId.value)
    anime()
  }
  const onClickStop = () => {
    isPlaying.value = false
    clearTimeout(clearId.value)
  }

  return {
    isPlaying,
    clearId,
    onClickPlay,
    onClickStop
  }
}
